import { Component, Inject, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { Navigate } from '@ngxs/router-plugin';
import { Actions, Select, Store, ofActionDispatched } from '@ngxs/store';
import { Certificate } from 'app/library/certificate/models/certificate.model';
import { SimpleCertificate } from 'app/library/certificate/models/simple-certificate.model';
import { CertificateService } from 'app/library/certificate/services/certificate.service';
import { ManageParticipantAttendancesDialogComponent } from 'app/library/event/components/dialogs/manage-participant-attendance-dialog/manage-participant-attendance-dialog.component';
import { AdminPermissions } from 'app/library/feature/enums/admin-permissions.enum';
import { FinalGrade } from 'app/library/final-grade/models/final-grade.model';
import { FinalGradeService } from 'app/library/final-grade/services/final-grade.service';
import { GradingSchemeService } from 'app/library/grading-scheme/services/grading-scheme.service';
import { AssignCertificatesToModuleUsersSuccess, DeleteModuleCertificate, DeleteModuleCertificateSuccess } from 'app/library/module-certificate/actions';
import { ModuleCertificateExtended } from 'app/library/module-certificate/models/module-certificate.extended.model';
import { ModuleCertificatesService } from 'app/library/module-certificates/services/module-certificates.service';
import { AttendanceStatus } from 'app/library/module-event-attendance/enums/attendance-status.enum';
import { AttendanceStatuses } from 'app/library/module-event-attendance/models/attendance-status';
import { ModuleEventAttendance } from 'app/library/module-event-attendance/models/module-event-attendance.model';
import { ModuleEventAttendanceService } from 'app/library/module-event-attendance/services/module-event-attendance.service';
import { ModuleFeatureService } from 'app/library/module-feature/services/module-feature.service';
import { SetModuleUser } from 'app/library/module-user/actions';
import { ModuleUser } from 'app/library/module-user/models/module-user.model';
import { ModuleType } from 'app/library/module/enums/moduleType.enum';
import { SectionRule } from 'app/library/module/enums/sectionRule.enum';
import { Module } from 'app/library/module/models/module.model';
import { ModuleService } from 'app/library/module/services/module.service';
import { FetchParticipantModule, FetchParticipantModuleSuccess } from 'app/library/my-profile-modules/actions';
import { PartialGrade } from 'app/library/partial-grade/models/partial-grade.model';
import { PartialGradeService } from 'app/library/partial-grade/services/partial-grade.service';
import { SectionCompletionForParticipantSuccess, UnsetUserSectionStatsForParticipant } from 'app/library/user-section/actions';
import { IModuleCompletionSection } from 'app/library/user-section/interfaces/module-completion-section.interface';
import { SectionStats, UserSectionStats } from 'app/library/user-section/models/user-section.model';
import { UserSectionStatsState } from 'app/library/user-section/models/user-section.state';
import { UserSectionService } from 'app/library/user-section/services/user-section.service';
import { ManageUserCertificatesDialogComponent } from 'app/main/pages/dialogs/manage-user-certificates-dialog/manage-user-certificates-dialog.component';
import { SnackBarTime } from 'app/projects/core/src/lib/constants/snack-bar';
import { UnsubscribeOnDestroy } from 'app/projects/core/src/lib/models/unsubscribe-on-destroy';
import { MaxBrainConfirmDialogComponent } from 'app/projects/shared/src/lib/components/dialogs/confirm/confirm.component';
import { FeatureSwitchName } from 'app/projects/shared/src/lib/enums/feature-switch.enum';
import { ModuleFeatureSwitchName } from 'app/projects/shared/src/lib/enums/module-feature-switch.enum';
import { ILanguageService } from 'app/projects/shared/src/lib/interfaces/language.interface';
import { FeatureSwitchPipe } from 'app/projects/shared/src/lib/pipes/feature-switch.pipe';
import { MAXBRAIN_LANGUAGE_SERVICE } from 'app/projects/shared/src/lib/services/language.token';
import { UnsetUser } from 'app/projects/user/src/lib/actions/unset-entity.action';
import { User } from 'app/projects/user/src/lib/models/user';
import { UserState } from 'app/projects/user/src/lib/models/user.state';
import { Observable } from 'rxjs';
import { map, take, takeUntil } from 'rxjs/operators';
import { ManageCompletionDialogComponent } from '../manage-completion-dialog/manage-completion-dialog.component';

@Component({
    selector: 'app-team-course-member-details-dialog',
    templateUrl: './team-course-member-details-dialog.component.html',
    styleUrls: ['./team-course-member-details-dialog.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class TeamCourseMemberDetailsDialogComponent extends UnsubscribeOnDestroy implements OnInit {
    @Select(UserSectionStatsState.getEntities)
    userSectionStats$: Observable<UserSectionStats[]>;

    @Input()
    title: string;

    @Input()
    participantId: string;

    @Input()
    moduleId: string;

    manageCertificateDialogRef: MatDialogRef<ManageUserCertificatesDialogComponent>;
    manageCompletionDialogRef: MatDialogRef<ManageCompletionDialogComponent>;
    manageParticipantAttendancesDialogRef: MatDialogRef<ManageParticipantAttendancesDialogComponent>;
    confirmDialogRef: MatDialogRef<MaxBrainConfirmDialogComponent>;

    user: User;
    currentModule: Module;
    moduleUser: ModuleUser;

    moduleCertificates: ModuleCertificateExtended[] = [];
    participantAttendances: ModuleEventAttendance[] = [];
    userSectionStatsPercentage: number;
    finalGrades: FinalGrade[];
    partialGrades: PartialGrade[];

    dataSource: SectionStats[];
    displayedColumns: string[] = ['section', 'timeSpent', 'visitedCount', 'completion'];
    isDataFetched = false;
    rippleDisabled = false;

    SectionRule = SectionRule;
    ModuleType = ModuleType;
    attendanceStatuses = AttendanceStatuses;
    AttendanceStatus = AttendanceStatus;

    isCurrentUserTenantAdmin: boolean;
    isGradebookFeatureEnabled: boolean;

    isModuleFeatureAttendanceActive: boolean;
    isCertificateOfAttendanceFeatureEnabled: boolean;

    constructor(
        public dialogRef: MatDialogRef<TeamCourseMemberDetailsDialogComponent>,
        private _store: Store,
        private _action$: Actions,
        private _moduleCertificatesService: ModuleCertificatesService,
        private _userSectionService: UserSectionService,
        private _finalGradeService: FinalGradeService,
        private _featureSwitchPipe: FeatureSwitchPipe,
        private _gradingSchemeService: GradingSchemeService,
        private _moduleService: ModuleService,
        private _matSnackBar: MatSnackBar,
        private _translateService: TranslateService,
        private _moduleEventAttendance: ModuleEventAttendanceService,
        private _moduleFeatureService: ModuleFeatureService,
        private _certificateService: CertificateService,
        private _matDialog: MatDialog,
        private _partialGradeService: PartialGradeService,
        @Inject(MAXBRAIN_LANGUAGE_SERVICE) public languageService: ILanguageService
    ) {
        super();

        this._finalGradeService.moduleFinalGrade$.pipe(takeUntil(this._unsubscribeAll)).subscribe((finalGrades) => {
            this.finalGrades = finalGrades;
        });

        this._partialGradeService.currentUserPartialGrade$.pipe(takeUntil(this._unsubscribeAll)).subscribe((partialGrades) => {
            this.partialGrades = partialGrades;
        });

        this._moduleEventAttendance.participantAttendancesSubject$.pipe(takeUntil(this._unsubscribeAll)).subscribe((participantAttendances) => {
            if (participantAttendances) {
                this.participantAttendances = participantAttendances;
            }
        });

        this.isGradebookFeatureEnabled = this._featureSwitchPipe.transform(FeatureSwitchName.Gradebook);
        this.isModuleFeatureAttendanceActive = this._moduleFeatureService.checkModuleFeatureStatus(ModuleFeatureSwitchName.Attendance);
        this.isCertificateOfAttendanceFeatureEnabled = this._featureSwitchPipe.transform(FeatureSwitchName.CertificateOfAttendance);
    }

    async ngOnInit(): Promise<void> {
        await this._moduleService.fetchModuleById(this.moduleId);
        this.currentModule = this._moduleService.getCurrentModule();

        await this._userSectionService.fetchUserSectionStatsForParticipant(this.currentModule.id, this.participantId);

        if (this.isCertificateOfAttendanceFeatureEnabled) {
            await this._moduleCertificatesService.fetchModuleCertificates();
        }

        if (this.currentModule.type !== 'e_learning' && this.isGradebookFeatureEnabled) {
            await this._gradingSchemeService.fetchGradingSchemeByModuleId(this.currentModule.id);

            await this._finalGradeService.fetchParticipantFinalGradesByModuleIdForParticipant(this.currentModule.id, this.participantId);
        }

        this.user = this._store.selectSnapshot(UserState.getMyInfo);
        this.isCurrentUserTenantAdmin = this.user.permissions.includes(AdminPermissions.TENANT_MANAGEMENT);

        this.moduleCertificates = this._moduleCertificatesService.getModuleCertificates();

        this._store.dispatch(new FetchParticipantModule({ userId: this.participantId, moduleId: this.currentModule.id, includeAnalytics: true }));
        this.moduleUser = await this._action$
            .pipe(
                takeUntil(this._unsubscribeAll),
                ofActionDispatched(FetchParticipantModuleSuccess),
                map(({ payload }: FetchParticipantModuleSuccess) => payload[0]),
                take(1)
            )
            .toPromise();

        if (this.moduleUser) {
            this._store.dispatch(new SetModuleUser(this.moduleUser));

            if (
                this.currentModule.sectionRule === SectionRule.TrackProgress ||
                this.currentModule.sectionRule === SectionRule.Sequential ||
                this.currentModule.type === ModuleType.ELearning
            ) {
                this.userSectionStats$.pipe(takeUntil(this._unsubscribeAll)).subscribe((value) => {
                    if (value) {
                        this.dataSource = value.find((userStats) => userStats.id === this.participantId).sectionStats;
                    }
                });

                this.userSectionStatsPercentage = this._userSectionService.getUserSectionStatsPercentage();
            }
        } else if (!this.isCurrentUserTenantAdmin) {
            throw new Error(`The current user is not assigned to the module with id ${this.currentModule.id}`);
        }

        this.isDataFetched = true;
    }

    manageGrades(): void {
        this._store.dispatch(new Navigate([`/modules/${this.currentModule.id}/edit/gradebook`]));
    }

    openManageParticipantAttendancesDialog(): void {
        this.manageParticipantAttendancesDialogRef = this._matDialog.open(ManageParticipantAttendancesDialogComponent, {
            width: '1280px',
            autoFocus: false,
        });

        this.manageParticipantAttendancesDialogRef.componentInstance.moduleId = this.currentModule.id;
        this.manageParticipantAttendancesDialogRef.componentInstance.participantId = this.participantId;
        this.manageParticipantAttendancesDialogRef.componentInstance.participantAttendances = this.participantAttendances;

        this.manageParticipantAttendancesDialogRef.afterClosed().subscribe(() => {
            this._store.dispatch(new FetchParticipantModule({ userId: this.participantId, moduleId: this.currentModule.id, includeAnalytics: true }));

            this.manageParticipantAttendancesDialogRef = null;
        });
    }

    async openDialogToGiveCertificate(): Promise<void> {
        this.manageCertificateDialogRef = this._matDialog.open(ManageUserCertificatesDialogComponent, {
            disableClose: false,
            width: '600px',
        });
        this.manageCertificateDialogRef.componentInstance.title = 'PAGE.MODULE_FORM.TAB.CERTIFICATE_SETTINGS.DIALOGS.MANAGE_USER_CERTIFICATES.GIVE_CERTIFICATE_TITLE';
        this.manageCertificateDialogRef.componentInstance.actionButtonText = 'PAGE.MODULE_FORM.TAB.CERTIFICATE_SETTINGS.BUTTON.GIVE_CERTIFICATE';
        this.manageCertificateDialogRef.componentInstance.moduleCertificates = this.moduleCertificates;

        this.manageCertificateDialogRef.afterClosed().subscribe(async (result) => {
            if (result?.selectedModuleCertificateIds && result?.selectedModuleCertificateIds.length) {
                const payload = {
                    moduleUserIds: Array(this.moduleUser.id),
                    moduleTemplateIds: result.selectedModuleCertificateIds,
                    sendNotification: result.sendNotifications,
                };

                this._moduleCertificatesService.assignCertificatesToModuleUsers(payload);

                this._action$.pipe(takeUntil(this._unsubscribeAll), ofActionDispatched(AssignCertificatesToModuleUsersSuccess), take(1)).subscribe(() => {
                    const successMessage = this._translateService.instant(
                        'PAGE.MODULE_FORM.TAB.CERTIFICATE_SETTINGS.DIALOGS.MANAGE_USER_CERTIFICATES.MESSAGE.ASSIGN_CERTIFICATE_TEMPLATE_SUCCESS'
                    );
                    this._matSnackBar.open(successMessage, 'OK', {
                        verticalPosition: 'top',
                        duration: SnackBarTime.medium,
                    });
                    this._store.dispatch(new FetchParticipantModule({ userId: this.participantId, moduleId: this.currentModule.id, includeAnalytics: true }));
                });
            }
        });
    }

    openDialogToRemoveCertificate(certificate: SimpleCertificate): void {
        this.confirmDialogRef = this._matDialog.open(MaxBrainConfirmDialogComponent, {
            disableClose: false,
        });

        this.confirmDialogRef.componentInstance.confirmTitle = 'GENERAL.BUTTON.CONFIRM';
        this.confirmDialogRef.componentInstance.confirmMessage = 'GENERAL.MESSAGE.REMOVE_CONFIRMATION';
        this.confirmDialogRef.componentInstance.confirmButtonColor = 'warn';
        this.confirmDialogRef.componentInstance.actionButtonText = 'GENERAL.BUTTON.DELETE';

        this.confirmDialogRef.afterClosed().subscribe(async (result) => {
            if (result) {
                this._store.dispatch(new DeleteModuleCertificate(certificate.id));
                this._action$.pipe(takeUntil(this._unsubscribeAll), ofActionDispatched(DeleteModuleCertificateSuccess), take(1)).subscribe(() => {
                    const successMessage = this._translateService.instant(
                        'PAGE.MODULE_FORM.TAB.CERTIFICATE_SETTINGS.DIALOGS.MANAGE_USER_CERTIFICATES.MESSAGE.UNASSIGN_CERTIFICATE_TEMPLATE_SUCCESS'
                    );
                    this._matSnackBar.open(successMessage, 'OK', {
                        verticalPosition: 'top',
                        duration: SnackBarTime.medium,
                    });
                    this._store.dispatch(new FetchParticipantModule({ userId: this.participantId, moduleId: this.currentModule.id, includeAnalytics: true }));
                });
            }
            this.confirmDialogRef = null;
        });
    }

    downloadModuleCertificate(certificate: Certificate): void {
        this._certificateService.downloadFinalGradeCertificate(certificate).then(() => {});
    }

    openManageCompletionDialog(): void {
        this.manageCompletionDialogRef = this._matDialog.open(ManageCompletionDialogComponent, {
            disableClose: false,
            width: '780px',
        });

        this.manageCompletionDialogRef.componentInstance.userSectionStats = this.dataSource;

        this.manageCompletionDialogRef.componentInstance.saveSections.pipe(takeUntil(this._unsubscribeAll)).subscribe((payload: IModuleCompletionSection[]) => {
            let isThereFalseValue = false;
            payload.forEach((value) => {
                if (value.completed === false) {
                    isThereFalseValue = true;
                }
            });

            if (isThereFalseValue) {
                this.confirmDialogRef = this._matDialog.open(MaxBrainConfirmDialogComponent, {
                    disableClose: false,
                });

                this.confirmDialogRef.componentInstance.confirmTitle = 'GENERAL.BUTTON.PROCEED_WITH_CHANGES';
                this.confirmDialogRef.componentInstance.confirmMessage = 'GENERAL.MESSAGE.MARKED_SECTIONS_NON_COMPLETED';
                this.confirmDialogRef.componentInstance.confirmButtonColor = 'accent';
                this.confirmDialogRef.componentInstance.actionButtonText = 'GENERAL.BUTTON.SAVE_ANYWAY';

                this.confirmDialogRef
                    .afterClosed()
                    .pipe(takeUntil(this._unsubscribeAll))
                    .subscribe(async (result) => {
                        if (result) {
                            this._userSectionService.bulkSectionCompletion(payload, parseInt(this.moduleUser.userId));
                        }
                        this.confirmDialogRef = null;
                    });
            } else {
                this._userSectionService.bulkSectionCompletion(payload, parseInt(this.moduleUser.userId));
            }

            this._action$
                .pipe(takeUntil(this._unsubscribeAll), ofActionDispatched(SectionCompletionForParticipantSuccess))
                .subscribe(async (action: SectionCompletionForParticipantSuccess) => {
                    this.moduleUser = Object.assign(new ModuleUser(), this.moduleUser, {
                        moduleUserProgress: Object.assign({}, this.moduleUser.moduleUserProgress, {
                            completedSectionsCount: this.dataSource.filter((stat) => stat.completed).length,
                        }),
                    });

                    const successMessage = this._translateService.instant('GENERAL.MESSAGE.SAVED');
                    this._matSnackBar.open(successMessage, 'OK', {
                        verticalPosition: 'top',
                        duration: SnackBarTime.medium,
                    });
                });
        });
    }

    ngOnDestroy(): void {
        this._store.dispatch(new UnsetUser());
        this._store.dispatch(new UnsetUserSectionStatsForParticipant());
        super.ngOnDestroy();
    }
}
